import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { getTaskById } from "~/store/selectors/selector.tasks.jsx";
import TaskPanelContainer from "../TaskPanelContainer.jsx";

const TaskPropertiesWrapper = ({ id, ...rest }) => {
  const task = useSelector((state) => getTaskById(state, id));
  return (
    <TaskPanelContainer
      {...rest}
      id={id}
      projectId={task.project_id}
      task={task}
    />
  );
};

TaskPropertiesWrapper.propTypes = {
  id: PropTypes.number.isRequired,
};

export default TaskPropertiesWrapper;
